import { render, staticRenderFns } from "./signup_byphone.vue?vue&type=template&id=d1039dc2&"
import script from "./signup_byphone.vue?vue&type=script&lang=js&"
export * from "./signup_byphone.vue?vue&type=script&lang=js&"
import style0 from "./signup_byphone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports